<template>
    <div class="breadcrumb theme-fontname">
      <a v-if="project.uxd.hideheader == '1'" :href="project.uxd.watermarkurl" :style="project.uxd.watermarkstylebreadcrumbs" class="theme-fontname" target="_blank">{{project.uxd.watermark}}</a>
        <template v-if="!project.searchVisible">
            <span class="breadcrumb-item theme-fontcolor" @click="goToLink('/')">{{project.uxd.productoverview}}</span>
            <span class="breadcrumb-item theme-fontcolor" v-bind:key="bc.link" @click="goToLink(bc.link)" v-for="bc of project.breadCrumbs"> &gt; {{bc.name}} </span>
        </template>
        <template v-else>
            <span class="breadcrumb-item theme-fontcolor">{{project.uxd.labelsearchresults}}</span>
            <span class="breadcrumb-item theme-fontcolor" @click="closeSearch()"> &gt; {{project.uxd.labelclose}}</span>
        </template>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'BreadCrumb',
        computed: {
            ...mapState([
                'project',
                'session'
            ])
        },
        methods: {
            ...mapActions([
                'navigateAfterSearch',
                'selectPartOrRootDrawingById',
                'selectDrawingById',
                'goToRoot'
            ]),
            goToLink(newLink) {
                if(newLink == '/') {
                  window.localStorage.setItem('partId', -1);
                  this.goToRoot();
                } else {
                  let comp = newLink.split('/');
                  if(comp.length == 3 && comp[1] == 'selectpartorrootdrawing') {
                    this.selectPartOrRootDrawingById(comp[2]);
                  } else if(comp.length == 3 && comp[1] == 'selectdrawing') {
                    this.selectDrawingById(comp[2]);
                  }
                }

            },
            closeSearch() {
              this.navigateAfterSearch(null)
            }
        }
    }
</script>

<style>
    .breadcrumb-item {
        margin-left: 5px;
        max-height: 30px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
